import { FormattedMessage } from 'react-intl';
import ExpanderPanel from '@rio-cloud/rio-uikit/ExpanderPanel';

import AnalyticsEvents from '@/analytics/AnalyticsEvents';
import Icon from './Icon';
import { Criticality } from './utils/types';

const StatusLegend = () => {
    const handleToggle = (isOpen: boolean) => {
        // Only track when the user expands the legend, not when collapsing it.
        if (isOpen) {
            AnalyticsEvents.expandStatusMeaning();
        }
    };

    return (
        <ExpanderPanel
            title={<FormattedMessage id="intl-msg:vehicle-warnings.statusLegend.title" />}
            bsStyle="separator"
            iconLeft
            bodyClassName="padding-0"
            className="separator-hidden margin-top-10"
            onToggle={handleToggle}
        >
            <div className="border border-color-light rounded padding-15 display-flex flex-column gap-15 bg-lightest">
                <div>
                    <div className="display-flex align-items-center gap-5 margin-bottom-5">
                        <Icon criticality={Criticality.SCHEDULE_SERVICE} size={24} />
                        <span className="text-medium">
                            <FormattedMessage id="intl-msg:vehicle-warnings.status.scheduleService" />
                        </span>
                    </div>
                    <span className="text-size-14 text-color-darker">
                        <FormattedMessage id="intl-msg:vehicle-warnings.statusLegend.scheduleService" />
                    </span>
                </div>
                <div>
                    <div className="display-flex align-items-center gap-5 margin-bottom-5">
                        <Icon criticality={Criticality.SERVICE_SOON} size={24} />
                        <span className="text-medium">
                            <FormattedMessage id="intl-msg:vehicle-warnings.status.serviceSoon" />
                        </span>
                    </div>
                    <span className="text-size-14 text-color-darker">
                        <FormattedMessage id="intl-msg:vehicle-warnings.statusLegend.serviceSoon" />
                    </span>
                </div>
                <div>
                    <div className="display-flex align-items-center gap-5 margin-bottom-5">
                        <Icon criticality={Criticality.INFORMATION} size={24} />
                        <span className="text-medium">
                            <FormattedMessage id="intl-msg:vehicle-warnings.status.information" />
                        </span>
                    </div>
                    <span className="text-size-14 text-color-darker">
                        <FormattedMessage id="intl-msg:vehicle-warnings.statusLegend.information" />
                    </span>
                </div>
            </div>
        </ExpanderPanel>
    );
};

export default StatusLegend;
